module.exports = __webpack_public_path__ + "55c80075bd825bfb990c057b3717a1b8.pdf";